<template>
  <div class="rank-custom-wrapper">
    <Tabs v-model="activeTab">
      <Tab header="Coachs prospectés (scrapping)">
        <ProspectedCoach />
      </Tab>
    </Tabs>
  </div>
</template>

<script>
import ProspectedCoach from "@/components/coach-manager/scrapping/ProspectedCoach";
import Tabs from "vue-strap/src/Tabs";
import Tab from "vue-strap/src/Tab";

export default {
  components: {
    ProspectedCoach,
    Tabs,
    Tab,
  },

  data() {
    return {
      activeTab: 0,
    };
  },
};
</script>
